import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environment/environment';
import { Observable } from 'rxjs';

import { CommentDraft, CommentResponse, Comment } from 'modules/shared/models/comment.models';

@Injectable()
export class CommentService {

  /**
   * Environment variable
   */
  private apiBase: string = environment.API_BASE;

  constructor(private httpClient: HttpClient) { }

  /**
   * Get list crps posts
   * @param crpId crpId (can get it in customer)
   */
  getComments(crpId: number): Observable<CommentResponse> {
    return this.httpClient.get<CommentResponse>(`${this.apiBase}/api/crps/${crpId}/posts/`);
  }

  /**
   * Create a new crps posts
   * @param crpId crpId (can get it in customer)
   * @param comment content, dialog, parent.. of new comment
   */
  createComment(crpId: number, comment: CommentDraft): Observable<Comment> {
    return this.httpClient.post<Comment>(`${this.apiBase}/api/crps/${crpId}/posts/`, comment);
  }

  /**
   * Delete comment
   * @param id comment ID
   */
  deleteComment(id: number) {
    return this.httpClient.delete(`${this.apiBase}/api/posts/${id}/`);
  }
}
